import React from 'react';
import './CartSnackbar.css';

const CartSnackbar = ({ open, total, onViewCart, onClose }) => {
  if (!open) return null;
  return (
    <div className="cart-snackbar">
      <div className="cart-snackbar-content">
        <strong>Cart Total: ₹{total}</strong>
        <button className="cart-snackbar-btn" onClick={onViewCart}>
          View Cart
        </button>
      </div>
      <button className="cart-snackbar-close" onClick={onClose}>&times;</button>
    </div>
  );
};

export default CartSnackbar; 